<template>
  <v-container>
    <v-row flex-column>
      <v-form
        id="japu-form"
        ref="japuform"
        v-model="valid"
        @submit.prevent="japuRegister"
        class="mx-auto"
        :disabled="loading"
      >
        <v-col cols="12" class="py-0">
          <v-text-field
            v-model="emailField"
            type="text"
            name="current-email"
            label="כתובת המייל שלך"
            required
            dense
            outlined
            solo
            prepend-inner-icon="mdi-email-outline"
            color="primary"
            class="primary--text mx-auto"
            :rules="emailRules"
            @copy.prevent
            @input="emailValidationNew = ''"
            @cut.prevent
            autocomplete
            :disabled="loading"
            dir="auto"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-text-field
            v-model="emailValidationNew"
            outlined
            solo
            dense
            :rules="emailValidationRules"
            type="text"
            label="הקלד שנית לצורך אימות"
            prepend-inner-icon="mdi-email-outline"
            class="text-field-input"
            ref="emailValidationField"
            required
            @paste.prevent
            :disabled="!isEmailValid"
            autocomplete="new-email"
            dir="auto"
          />
        </v-col>
        <v-col cols="12" class="py-0 email-field">
          <v-text-field
            v-model="passwordField"
            type="password"
            name="current-password"
            label="בחירת סיסמה"
            required
            dense
            outlined
            solo
            prepend-inner-icon="mdi-lock"
            color="primary"
            :rules="passwordRules"
            :disabled="loading"
            dir="auto"
          ></v-text-field>
        </v-col>

        <v-col cols="12" class="text-center py-0">
          <v-checkbox v-model="agreeToTerms" :rules="termsRules" class="mt-0">
            <template v-slot:label>
              <div class="display-12">
                <span class="red--text">*</span>
                מאשר/ת את
                <span>
                  <a
                    target="_blank"
                    href="https://www.drushim.co.il/article/2/"
                    @click.stop
                  >
                    תנאי השימוש
                  </a>
                  , קבלת הצעות עבודה ודיוורים במייל
                </span>
              </div>
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" class="text-center py-0">
          <v-checkbox v-model="rememberMe" :label="'זכור אותי'" class="mt-0">
            <template v-slot:label>
              <div class="display-12">
                <span class="red--text">*</span>
                זכור אותי
              </div>
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" class="text-center py-0 mt-0">
          <v-btn
            type="submit"
            dense
            rounded
            color="primary"
            class="mx-auto"
            :disabled="!valid"
            :loading="loading"
          >
            יצירת סוכן חכם
          </v-btn>
        </v-col>
      </v-form>
    </v-row>
    <small
      v-if="error"
      class="d-block text-center red--text py-2 error-message"
    >
      {{ errorMessgae }}
    </small>
  </v-container>
</template>

<script>
import { t } from '@/store/modules/homeDrushim/constantsContent';
import { REGISTER_JAPU } from '@/lib/api.js';
import gtm from '@/lib/gtm';
import errors from '@/lib/errorsList';
import { termsRules, emailRules, passwordRules } from '@/lib/rules.js';
// import recaptchaV3 from '@/components/mixins/recaptchaV3';

export default {
  name: 'JapuForm',
  // mixins: [recaptchaV3],
  props: {
    JAPUProperties: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      valid: false,
      loading: false,
      error: false,
      errorMessgae: null,
      emailField: null,
      emailValidationNew: null,
      passwordField: null,
      agreeToTerms: false,
      rememberMe: true,
      errorSign: false,
      termsRules,
      emailRules,
      passwordRules,
      emailValidationRules: [(v) => !!v && this.checkEmailValidation()],
    };
  },

  computed: {
    isEmailValid() {
      return /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(
        this.emailField
      );
    },
  },
  methods: {
    checkEmailValidation() {
      if (this.emailValidationNew.localeCompare(this.emailField)) {
        return t('titles.errorMessages.emailValidationFailed');
      } else {
        return true;
      }
    },
    async japuRegister() {
      try {
        if (this.$refs.japuform.validate()) {
          this.loading = true;

          const data = {
            Email: this.emailField,
            Password: this.passwordField,
            AgreeToTerms: this.agreeToTerms,
            RememberMe: this.rememberMe,
            Source: 5,
            FullSignUp: false,
            Categories: this.JAPUProperties.Categories,
            Locations: this.JAPUProperties.Locations,
            Keywords: this.JAPUProperties.Keywords,
            CityId: 1201,
          };

          // const recaptcha = await this.recaptchaCheck('registerJAPU');
          // if (!recaptcha) {
          //   throw 'ERROR => recaptcha';
          // }

          const response = await this.$axios.post(REGISTER_JAPU, data);

          if (response.data.IsError) {
            throw response.data.ErrorsMessages;
          }

          gtm({
            email: this.emailField,
            phone: '',
            event: 'smart_agent_gads',
          });

          if (response.data.RegistrationSource) {
            gtm({
              ID: response.data.RegistrationSource.RegistrationIdentifier,
              registration: response.data.RegistrationSource.Source,
              event: 'leadcrmregistration',
            });
          }
          this.loading = false;
          this.closeJapu();
          this.$nuxt.$loading.start();
          await this.$auth.loginWith('local', {
            data: {
              email: this.emailField,
              password: this.passwordField,
            },
          });
          this.$nuxt.$loading.finish();
        }
      } catch (error) {
        this.errorSign = errors[Object.keys(error)[0]];
        this.submitError(this.errorSign);
        console.log(error);
        this.loading = false;
      }
    },
    submitError(err) {
      this.errorMessgae = err;
      this.error = true;
      this.loading = false;
    },
    closeJapu() {
      this.$emit('closeJapu');
    },
  },
};
</script>

<style lang="scss" scoped>
.theme--light.v-input input::placeholder {
  text-align: right;
}
</style>
